
import React, { useState, createContext, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const OrganizationContext = createContext();

export const OrganizationProvider = ({ children }) => {
    const [organizationIdInternal, setOrganizationIdInternal] = useState(undefined)
    const [wasStorageChecked, setWasStorageChecked] = useState(false);

    useEffect(() => {

        const getData = async () => {
            try {
                const organizationId = await AsyncStorage.getItem('@organizationId')
                setOrganizationIdInternal(organizationId);
                console.log('organizationIddasdkfbcskejc', organizationId)
            } catch (e) {
                // error reading value
                console.log('getData Reading Error: ', e);
            }
            setWasStorageChecked(true);
        }

        getData();
    }, [])

    const setOrganizationId = async organizationId => {
        // todo use async storage
        // set in async storage

        try {
            await AsyncStorage.setItem('@organizationId', organizationId)
            setOrganizationIdInternal(organizationId)
        } catch (e) {
            // saving error
            console.log('storeData Saving Error: ', e);
        }

    }

    return (
        <OrganizationContext.Provider
            value={{
                organizationId: organizationIdInternal,
                setOrganizationId,
                wasStorageChecked
            }}>
            {children}
        </OrganizationContext.Provider>
    )
}